module.exports = __webpack_public_path__ + "static/media/go.e25a695b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/workout/go.mp3
// module id = 2032
// module chunks = 0